import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ToastHandler from '../../components/toasthandler';
import Loader from '../../components/loader';
import LoaderRing from '../../components/loaderring';
import AssetConfig from '../../components/assetconfig';
import AssetSelect from '../../components/assetselect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import CreateAutomation from './createautomation';
import ListAutomations from './listautomations';
import Modal from '../../components/modal';

import CustodianAlert from '../../components/custodianalert';

import {
  fetchSecurity,
  getAutomationFlows,
  createAutomationFlow,
  updateAutomationFlow,
  deleteAutomationFlow,
} from '../../actions';

const qs = require('query-string');

class Automation extends Component {
  constructor(props) {
    super(props);
    const filterParams = qs.parse(this.props.location.search);
    this.state = {
      filterParams,
      modalComponent: null,
      wideModal: true,
      otcPairs: {},
      otcAssets: [],
      assetPairs: [],
      assetDeposit: '',
      assetBuy: [
        {
          asset: '',
          percentage: 0,
          id: 'ab-0',
        },
      ],
      assetBuyList: [],
      assetDepositList: [],
      typeFrom: 'DEPOSIT',
      typeTo: 'BUY_CRYPTO',
      priority: '',
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.isOfType = this.isOfType.bind(this);
    this.assetsInitial = this.assetsInitial.bind(this);
    this.depositChange = this.depositChange.bind(this);
    this.buyChange = this.buyChange.bind(this);
    this.percentChange = this.percentChange.bind(this);
    this.addBuy = this.addBuy.bind(this);
    this.removeBuy = this.removeBuy.bind(this);
    this.handleCreateAutomation = this.handleCreateAutomation.bind(this);
    this.handleUpdateAutomation = this.handleUpdateAutomation.bind(this);
    this.handleDeleteAutomation = this.handleDeleteAutomation.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { pair } = this.state;
    dispatch(fetchSecurity());
    this.assetsInitial();
    dispatch(getAutomationFlows());
  }

  toggleModal(component, wideModal) {
    this.setState({
      modalComponent: component,
      wideModal: wideModal,
    });
  }

  isOfType(asset, type) {
    let useAsset;
    if (asset) {
      useAsset = asset.toUpperCase();
    }
    let useType;
    if (type) {
      useType = type.toUpperCase();
    }
    let typeAssets;
    let isType;
    if (AssetConfig && AssetConfig.length) {
      typeAssets = AssetConfig.filter((item) => {
        return item.type === useType;
      });
    }
    if (typeAssets && typeAssets.length) {
      isType = typeAssets.find((item) => {
        return item.handle === useAsset;
      });
    }
    if (isType) {
      return true;
    }
    return false;
  }

  assetsInitial() {
    const { assets, pairs } = this.props;

    const otcPairs = {};
    const assetPairs = [];
    let allAssets = [];
    let uniqueAssets = [];
    const frontEnabled = [];
    let useAssets = [];
    let useAssetPairs = [];

    // get all otc enabled pairs
    if (pairs && Object.keys(pairs).length) {
      Object.keys(pairs).forEach((key) => {
        if (pairs[key] && pairs[key].permissions) {
          if (pairs[key].permissions.includes('OTC')) {
            otcPairs[key] = pairs[key];
          }
        }
      });
    }
    if (otcPairs && Object.keys(otcPairs).length) {
      Object.keys(otcPairs).forEach((key) => {
        if (otcPairs[key] && otcPairs[key].alt) {
          assetPairs.push(otcPairs[key].alt.split(':'));
        }
      });
      // split otc enabled pairs into otc enabled assets
      allAssets = [].concat.apply([], assetPairs);
      // remove duplicate assets
      uniqueAssets = [...new Set(allAssets)];
    }
    if ((AssetConfig && AssetConfig.length)) {
      AssetConfig.map((asset) => {
        if (asset.enabled) {
          // get list of frontenabled assets;
          frontEnabled.push(asset.handle);
        }
      });
    }
    if ((uniqueAssets && uniqueAssets.length) && (frontEnabled && frontEnabled.length)) {
      // get list of otc enabled assets that are frontenabled
      useAssets = uniqueAssets.filter((asset) => {
        return frontEnabled.includes(asset);
      });
    }

    let otcAssets;
    let assetBuyList;
    let assetDepositList;
    if ((assets && assets.length) && (useAssets && useAssets.length)) {
      // filter all assets by useAssets and format to array of objects
      otcAssets = assets
        .filter((asset) => {
          return useAssets.includes(asset.handle);
        })
        .map((asset) => {
          return (
            {
              name: asset.name.toUpperCase(),
              asset: asset.handle,
              defaults: asset.defaults,
            }
          );
        });
    }

    if (otcAssets && otcAssets.length) {
      assetBuyList = [...otcAssets];
      assetDepositList = [...otcAssets];
    }

    // TEMP only allow BTC deposit
    if (assetBuyList) {
      assetDepositList = assetDepositList.filter((item) => {
        return item.asset === 'BTC';
      });
    }

    if (assetDepositList && assetDepositList.length) {
      // only allow deposit to be crypto
      assetDepositList = assetDepositList.filter((item) => {
        return this.isOfType(item.asset, 'CRYPTO');
      });
    }

    if (assetBuyList && assetDepositList) {
      this.setState({ otcPairs, otcAssets, assetPairs, assetBuyList, assetDepositList, frontEnabled });
    }
  }

  depositChange(event) {
    const { dispatch, assets } = this.props;
    const { assetDeposit, assetBuy, pair, otcAssets, aAssets, bAssets, assetPairs } = this.state;
    const { assetBuyList, assetDepositList, frontEnabled  } = this.state;

    let target = event.target;

    let assetBuyListNew;

    let enabledPairs;
    let splitPairs;
    let uniqueAssets;
    let frontAssets;
    let useAssets;

    if (assetPairs && assetPairs.length) {
      // get list of assetDeposit enabled pairs
      enabledPairs = assetPairs.filter(function(pair) {
        return pair.includes(target.value);
      });

      if (enabledPairs && enabledPairs.length) {
        // split pairs into asset
        splitPairs = [].concat.apply([], enabledPairs);
        // remove duplicate assets
        if (splitPairs && splitPairs.length) {
          uniqueAssets = [...new Set(splitPairs)];
        }
      }
    }

    if (uniqueAssets && uniqueAssets.length) {
      frontAssets = uniqueAssets.filter((asset) => {
        return frontEnabled.includes(asset);
      });
    }

    if ((assets && assets.length) && (frontAssets && frontAssets.length)) {
      // filter all assets by frontAssets and format to array of objects
      useAssets = assets
        .filter((asset) => {
          return frontAssets.includes(asset.handle);
        })
        .map((asset) => {
          return (
            {
              name: asset.name.toUpperCase(),
              asset: asset.handle,
              defaults: asset.defaults,
            }
          );
        });
    }

    if (useAssets && useAssets.length) {
      // remove assetDeposit from buy options
      assetBuyListNew = useAssets.filter((item) => {
        return item.asset !== target.value;
      });
    }

    this.setState({
      'assetDeposit': target.value,
      'assetBuyList': assetBuyListNew,
      'assetBuy': [
        {
          asset: '',
          percentage: 0,
          id: 'ab-0'
        },
      ],
    });
  }

  buyChange(event) {
    const { assetBuy } = this.state;

    let target = event.target;

    let useAssetBuy = [];
    if (assetBuy) {
      useAssetBuy = assetBuy;
    }

    let objIndex = Number(0);

    if (useAssetBuy && useAssetBuy.length) {
      objIndex = useAssetBuy.findIndex((obj => obj.id === target.id));
    }

    if (useAssetBuy[objIndex]) {
      useAssetBuy[objIndex].asset = target.value;
    }

    this.setState({
      'assetBuy': useAssetBuy,
    });
  }

  percentChange(event) {
    const { assetBuy } = this.state;

    let target = event.target;

    let useAssetBuy = [];
    if (assetBuy) {
      useAssetBuy = assetBuy;
    }

    let objIndex = Number(0);

    if (useAssetBuy && useAssetBuy.length) {
      objIndex = useAssetBuy.findIndex((obj => obj.id === target.id));
    }

    if (useAssetBuy[objIndex]) {
      useAssetBuy[objIndex].percentage = Number(target.value);
    }

    this.setState({
      'assetBuy': useAssetBuy,
    });
  }

  addBuy() {
    const { assetBuy } = this.state;

    let useAssetBuy = [];
    if (assetBuy && assetBuy.length) {
      useAssetBuy = assetBuy;
    }

    const useId = 'ab-' + Date.now().toString(36) + Math.random().toString(36).substr(2);

    useAssetBuy.push({
      asset: '',
      percentage: 0,
      id: useId,
    });

    this.setState({
      'assetBuy': useAssetBuy,
    });
  }

  removeBuy(useId) {
    const { assetBuy } = this.state;

    let useAssetBuy = [];
    if (assetBuy && assetBuy.length) {
      useAssetBuy = assetBuy;
    }

    if (useAssetBuy && useAssetBuy.length) {
      useAssetBuy = useAssetBuy.filter((item) => {
        return item.id !== useId;
      });
    }

    this.setState({
      'assetBuy': useAssetBuy,
    });
  }

  handleCreateAutomation() {
    const { dispatch } = this.props;
    const { assetDeposit, assetBuy, assetBuyList, assetDepositList, priority, typeFrom, typeTo } = this.state;

    let useAssetBuy = assetBuy;

    if (assetBuy && assetBuy.length) {
      useAssetBuy = assetBuy.map(({ id, ...object }) => object);
    }

    const data = {
      from: typeFrom,
      to: typeTo,
      meta: {
        depositAsset: assetDeposit,
        assetsToBuy: useAssetBuy,
      }
    };

    dispatch(createAutomationFlow(data))
    .then((res) => {
      if (res.type === 'CREATE_AUTOMATION_FLOW_SUCCESS') {
        dispatch(getAutomationFlows());
        this.setState({
          'assetDeposit': '',
          'assetBuyList': '',
          'assetBuy': [
            {
              asset: '',
              percentage: 50,
              id: 'ab-0'
            },
          ],
        });
        this.toggleModal(null);
      }
    });
  }

  handleUpdateAutomation(newPriority, automationReference) {
    const { dispatch } = this.props;

    const usePriority = Number(newPriority);

    const data = {
      priority: usePriority,
    };

    dispatch(updateAutomationFlow(data, automationReference))
    .then((res) => {
      if (res.type === 'UPDATE_AUTOMATION_FLOW_SUCCESS') {
        dispatch(getAutomationFlows());
        this.toggleModal(null);
      }
    });
  }

  handleDeleteAutomation(automationReference) {
    const { dispatch } = this.props;
    dispatch(deleteAutomationFlow(automationReference))
    .then((res) => {
      if (res.type === 'DELETE_AUTOMATION_FLOW_SUCCESS') {
        dispatch(getAutomationFlows());
        this.toggleModal(null);
      }
    });
  }

  render() {
    const { user, errors, success } = this.props;
    const { assetDeposit, assetBuy, assetBuyList, assetDepositList} = this.state;

    let otpEnabled;
    let withEnabled;
    if (user && user.security) {
      const otpHandle = user.security.find(e => e.typeHandle === 'OTP');
      if (otpHandle && otpHandle.statusHandle === 'ACTIVATED') {
        otpEnabled = true;
      }
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        otpEnabled = true;
      }
    }

    // User Verified
    const userVerified = user && user.me && user.me.flags && user.me.flags.verified;
    let autoErr;

    if (!otpEnabled && !userVerified) {
      autoErr = 'Account must be verified & 2FA enabled';
    }
    if (!otpEnabled && userVerified) {
      autoErr = '2FA must be enabled';
    }
    if (otpEnabled && !userVerified) {
      autoErr = 'Account must be verified';
    }
    if (otpEnabled && userVerified) {
      withEnabled = true;
    }

    const tradesDisabled = ((user && user.me && user.me.flags && user.me.flags.tradesDisabled) && (user.me.flags.tradesDisabled === true)) && ((user && user.me && user.me.flags && user.me.flags.verified) && (user.me.flags.verified === true));

    if (tradesDisabled) {
      otpEnabled = false;
      withEnabled = false;
    }

    let automationDisabled
    if (!otpEnabled || !withEnabled) {
      automationDisabled = true;
    }

    let hasEmptyBuy;

    let hasZeroPercent;

    if (assetBuy && assetBuy.length) {
      hasEmptyBuy = assetBuy.find((item) => {
        return item.asset === '';
      });
    }

    if (assetBuy && assetBuy.length) {
      hasZeroPercent = assetBuy.find((item) => {
        return !item.percentage || (item.percentage <= 0);
      });
    }

    const newAutomationComplete = !hasEmptyBuy && !hasZeroPercent && assetDeposit;

    return (
      <div className="grid-x vt-automate">
        <ToastHandler errors={errors} success={success} />
        {this.state.modalComponent && (
          <Modal
            toggleModal={this.toggleModal}
            modalComponent={this.state.modalComponent}
            wideModal={this.state.wideModal}
          />
        )}
        <CreateAutomation
          assetDeposit={assetDeposit}
          assetBuy={[...assetBuy]}
          assetBuyList={assetBuyList}
          assetDepositList={assetDepositList}
          removeBuy={this.removeBuy}
          addBuy={this.addBuy}
          percentChange={this.percentChange}
          buyChange={this.buyChange}
          depositChange={this.depositChange}
          isOfType={this.isOfType}
          newAutomationComplete={newAutomationComplete}
          handleCreateAutomation={this.handleCreateAutomation}
          toggleModal={this.toggleModal}
          modalComponent={this.state.modalComponent}
          autoErr={autoErr}
          automationDisabled={automationDisabled}
        />
        <ListAutomations
          toggleModal={this.toggleModal}
          modalComponent={this.state.modalComponent}
          handleUpdateAutomation={this.handleUpdateAutomation}
          handleDeleteAutomation={this.handleDeleteAutomation}
          autoErr={autoErr}
          automationDisabled={automationDisabled}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
  automations: state.automation.automations,
  loading: state.automation.loading,
  errors: state.automation.errors,
  success: state.automation.success,
});

export default withRouter(connect(mapStateToProps)(Automation));
